import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotComics from './components/HotComics';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';

const homeSEO = {
  title: '女神漫画网 | 女神漫画下拉式在线阅读与免费全集',
  description:
    '女神漫画网专为手机端优化，提供女神漫画下拉式在线阅读模式，流畅滚动看全集。涵盖女神漫画下拉式免费韩漫、日漫等热门作品，无需翻页，沉浸式追漫体验。',
  keywords:
    '女神漫画网,女神漫画下拉式,女神漫画下拉式在线阅读,女神漫画下拉式免费,女神漫画下拉式全集,女神漫画下拉式韩漫,女神漫画下拉式日漫,下拉式漫画大全,免费全集下拉式,流畅手机漫画阅读',
  canonicalUrl: 'https://nvshenmh.com/',
  ogImage:
    'https://readdy.ai/api/search-image?query=A%20stylized%20minimalist%20illustration%20of%20a%20cozy%20reading%20corner%20with%20floating%20comic%20pages%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20lighting%2C%20artistic%20flat%20design&width=1200&height=630&seq=og-home&orientation=landscape',
  structuredData: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '女神漫画网',
    url: 'https://nvshenmh.com/',
    description:
      '女神漫画网专为手机端优化，提供女神漫画下拉式在线阅读模式，流畅滚动看全集。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://nvshenmh.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
};

const orgData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '女神漫画网',
  url: 'https://nvshenmh.com/',
  description: '女神漫画下拉式在线阅读平台，提供免费全集韩漫日漫阅读体验。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@nvshenmh.com',
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <>
      <SEO data={homeSEO} />
      {/* Organization structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgData) }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotComics />
        <LatestUpdates />
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <RankingSection />
        </div>

        {/* CTA Section */}
        <section className="relative w-full py-16 md:py-20 my-10 overflow-hidden rounded-none max-w-[1400px] mx-auto">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20abstract%20illustration%20with%20soft%20floating%20book%20pages%20and%20gentle%20light%20rays%2C%20coral%20and%20cream%20color%20palette%2C%20minimalist%20flat%20design%2C%20cozy%20reading%20atmosphere%2C%20soft%20gradients&width=1600&height=400&seq=cta-home-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/30"></div>
          <div className="relative z-10 text-center px-4">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-3">
              立即开始你的阅读之旅
            </h2>
            <p className="text-sm text-white/80 mb-6 max-w-[500px] mx-auto">
              女神漫画下拉式免费全集等你来发现，流畅滚动，沉浸式阅读体验
            </p>
            <a
              href="/category/all"
              className="inline-block px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-all duration-300"
            >
              浏览全部漫画
            </a>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}